import { render, staticRenderFns } from "./NewAMForgotInfoRootComponent.vue?vue&type=template&id=6abbe74b&scoped=true"
import script from "./NewAMForgotInfoRootComponent.vue?vue&type=script&lang=js"
export * from "./NewAMForgotInfoRootComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAMForgotInfoRootComponent.vue?vue&type=style&index=0&id=6abbe74b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abbe74b",
  null
  
)

export default component.exports